import BookOpenIcon from '@persona-id/design-tokens/icons/BookOpenIcon';
import CircleCheckIcon from '@persona-id/design-tokens/icons/CircleCheckIcon';
import CircleHelpIcon from '@persona-id/design-tokens/icons/CircleHelpIcon';
import CodeIcon from '@persona-id/design-tokens/icons/CodeIcon';
import UserIcon from '@persona-id/design-tokens/icons/UserIcon';

export const popularLinks = [
  {
    name: 'linkedin',
    icon: <UserIcon />,
    title: 'Get help verifying your identity on LinkedIn',
    link: 'https://help.withpersona.com/end-users/linkedin/get-verified/',
  },
  {
    name: 'help-center',
    icon: <CircleHelpIcon />,
    title: 'Visit the Help Center',
    link: 'https://help.withpersona.com',
  },
  {
    name: 'docs',
    icon: <CodeIcon />,
    title: 'Review developer documentation',
    link: 'https://docs.withpersona.com/docs',
  },
  {
    name: 'platform-status',
    icon: <CircleCheckIcon />,
    title: 'View platform status & scheduled maintenance',
    link: 'https://status.withpersona.com/',
  },
  {
    name: 'academy',
    icon: <BookOpenIcon />,
    title: 'Take courses about identity & Persona’s proudcts',
    link: 'https://academy.withpersona.com',
  },
];

export enum HelpCategoryName {
  Billing = 'billing',
  EndUser = 'end-user',
  Implementation = 'implementation',
  Other = 'other',
  ReportIssue = 'report-issue',
  ProductionAccess = 'production-access',
  Sales = 'sales',
}

export interface HelpCategory {
  name: HelpCategoryName;
  title: string;
  requiresLoggedIn: boolean;
  hasCustomContactFormFlow: boolean;
  tags: string[];
  placeholderText: string;
}

const DEFAULT_PLACEHOLDER_TEXT =
  'Please be as detailed as you can, including the steps you’ve already tried and links to relevant pages.';

export const helpCategories = [
  {
    name: HelpCategoryName.EndUser,
    title: 'Verifying my identity',
    requiresLoggedIn: false,
    hasCustomContactFormFlow: true,
    tags: ['end-user-support-form'],
    placeholderText: DEFAULT_PLACEHOLDER_TEXT,
  },
  {
    name: HelpCategoryName.Sales,
    title: 'Evaluating a plan or feature & answering questions about pricing',
    requiresLoggedIn: false,
    hasCustomContactFormFlow: true,
    tags: ['sales-support-form'],
    placeholderText:
      'Please include information about the plan or feature you are requesting more information about.',
  },
  {
    name: HelpCategoryName.Implementation,
    title: 'Implementing or configuring a Persona product or feature',
    requiresLoggedIn: true,
    hasCustomContactFormFlow: false,
    tags: [],
    placeholderText:
      'Please specify the ID of the template, what you are trying to achieve, and what is blocking you. Make sure to include error messages and/or a link to a screen recording.',
  },
  {
    name: HelpCategoryName.ReportIssue,
    title: 'Addressing an issue with a specific Inquiry or Verification',
    requiresLoggedIn: true,
    hasCustomContactFormFlow: true,
    tags: [],
    placeholderText: DEFAULT_PLACEHOLDER_TEXT,
  },
  {
    name: HelpCategoryName.Billing,
    title: 'Addressing a billing issue',
    requiresLoggedIn: true,
    hasCustomContactFormFlow: false,
    tags: ['billing'],
    placeholderText:
      'Please be as detailed as you can, including the invoice number if applicable.',
  },
  {
    name: HelpCategoryName.ProductionAccess,
    title: 'Checking the status of my request for a trial or production access for Persona',
    requiresLoggedIn: true,
    hasCustomContactFormFlow: true,
    tags: ['prospect'],
    placeholderText: DEFAULT_PLACEHOLDER_TEXT,
  },
  {
    name: HelpCategoryName.Other,
    title: 'Something else',
    requiresLoggedIn: true,
    hasCustomContactFormFlow: false,
    tags: [],
    placeholderText: DEFAULT_PLACEHOLDER_TEXT,
  },
];
